import React, { useState } from 'react';
import aiData from './data.json';
import FundingMap from './FundingMap'; // Import the new component

const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

function App() {
  const [monthIndex, setMonthIndex] = useState(0);

  return (
    <div style={{ padding: '20px', backgroundColor: '#0f172a', color: 'white', minHeight: '100vh', fontFamily: 'sans-serif' }}>
      <h1 style={{ textAlign: 'center', margin: '0em 2em' }}>AI Global Funding 2025</h1>
      <p style = {{textAlign: 'center', fontSize:'0.9em', fontFamily: 'Inter', padding: '0em 2em'}}> This is a <b style={{ fontColor: '#000000'}}>tracker</b> for the funding recieved by major AI companies in the year of 2025 </p>

      <div style={{ maxWidth: '800px', margin: '0 auto 20px auto' }}>
        <input
          type="range" min="0" max="11" value={monthIndex}
          onChange={(e) => setMonthIndex(parseInt(e.target.value))}
          style={{ width: '100%', accentColor: '#00ffcc' }}
        />
        <h2 style={{ textAlign: 'center', color: '#00ffcc' }}>{months[monthIndex]} 2025</h2>
      </div>

      {/* Use the component and pass data via "props" */}
      <FundingMap
        aiData={aiData}
        monthIndex={monthIndex}
        width={900}
        height={500}
      />
    </div>
  );
}

export default App;
